export default function isContractInitialized () {
  return window.web3Service !== null
    && window.contract !== null
    && window.oldWeb3Service !== null
    && window.oldWeb3Contract !== null
    && Storage.getState().account.currentAccount !== null
    && Storage.getState().account.currentAccount !== undefined;
}


// WEBPACK FOOTER //
// ./src/utils/ContractInitializationState.js